export default [
  {
    path: '/feriado/',
    name: 'feriado',
    title: 'feriado',
    component: () => import('../views/FeriadoView.vue'),
    redirect: { name: 'feriado-listar' },
    children: [
      {
        path: 'welcome',
        name: 'feriado-listar',
        meta: {
          title: 'Feriado',
        },
        component: () => import('../views/FeriadoWelcomeView.vue'),
      },
      {
        path: 'add',
        name: 'feriado-cadastrar',
        component: () => import('../views/FeriadoFormView.vue'),
        meta: {
          title: 'Cadastrar feriado',
        },
      },
      {
        path: ':id',
        name: 'feriado-editar',
        meta: {
          title: 'Editar feriado',
        },
        component: () => import('../views/FeriadoFormView.vue'),
      },
    ],
  },
];
